import config from 'react-global-configuration';
import { userGetLoaded } from '../Entity/User';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '../UI';
export var userGetCurrent = function userGetCurrent() {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'current', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    fetch("".concat(API_URL, "/user?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) return response.json();else throw new Error();
    }).then(function (response) {
      dispatch(userGetLoaded(response.uid[0].value, response));
      dispatch(userSetCurrentUid(response.uid[0].value));
      dispatch(userSetLoggedIn(true));
      dispatch(setOperationStatus('user', 'current', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(userSetLoggedIn(false));
      dispatch(userSetCurrentUid(null));
      dispatch(setOperationStatus('user', 'current', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var userLogin = function userLogin(username, password) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'login', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    fetch("".concat(API_URL, "/user/login?_format=json"), {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        name: username,
        pass: password
      })
    }).then(function (response) {
      if (response.ok) return response.json();else throw new Error();
    }).then(function () {
      dispatch(userGetCurrent());
      dispatch(setOperationStatus('user', 'login', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('user', 'login', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var userLogout = function userLogout() {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'logout', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var logoutToken;
    fetch("".concat(API_URL, "/session/token/logout?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      logoutToken = response.logout_token;
      fetch("".concat(API_URL, "/user/logout?_format=json&token=").concat(logoutToken), {
        method: 'POST',
        credentials: 'include'
      }).then(function () {
        dispatch(userSetLoggedIn(false));
        dispatch(userSetCurrentUid(null));
        dispatch(setOperationStatus('user', 'logout', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'logout', UI_OPERATION_STATUS_ERROR));
      });
    });
  };
};
export var oneTimeLogin = function oneTimeLogin(uid, timestamp, hash) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'one_time_login', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var csrfToken;
    fetch("".concat(API_URL, "/rest/session/token?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/login/token?_format=json"), {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          uid: uid,
          timestamp: timestamp,
          hash: hash
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function (response) {
        dispatch(passResetToken(response.pass_reset_token));
        dispatch(validOneTimeLogin(true));
        dispatch(userGetCurrent());
        dispatch(setOperationStatus('user', 'one_time_login', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(passResetToken(null));
        dispatch(validOneTimeLogin(false));
        dispatch(setOperationStatus('user', 'one_time_login', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var forgotPassword = function forgotPassword(name) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'forgot_password', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var csrfToken;
    fetch("".concat(API_URL, "/rest/session/token?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/reset?_format=json"), {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          name: name
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function () {
        dispatch(setOperationStatus('user', 'forgot_password', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'forgot_password', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var resetPassword = function resetPassword(password, passResetToken) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'reset_password', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var csrfToken;
    fetch("".concat(API_URL, "/rest/session/token?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/password?_format=json"), {
        method: 'PATCH',
        credentials: 'include',
        body: JSON.stringify({
          password: password,
          pass_reset_token: passResetToken
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function () {
        dispatch(setOperationStatus('user', 'reset_password', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'reset_password', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var SET_UID = 'SET_UID';
export function userSetCurrentUid(data) {
  return {
    type: SET_UID,
    data: data
  };
}
export var SET_LOGGED_IN = 'SET_LOGGED_IN';
export function userSetLoggedIn(data) {
  return {
    type: SET_LOGGED_IN,
    data: data
  };
}
export var SET_VALID_ONE_TIME_LOGIN = 'SET_VALID_ONE_TIME_LOGIN';
export function validOneTimeLogin(data) {
  return {
    type: SET_VALID_ONE_TIME_LOGIN,
    data: data
  };
}
export var SET_PASSWORD_RESET_TOKEN = 'SET_PASSWORD_RESET_TOKEN';
export function passResetToken(data) {
  return {
    type: SET_PASSWORD_RESET_TOKEN,
    data: data
  };
}